import { render, staticRenderFns } from "./commerce-card.vue?vue&type=template&id=30a5d90e"
import script from "./commerce-card.vue?vue&type=script&lang=js"
export * from "./commerce-card.vue?vue&type=script&lang=js"
import style0 from "./commerce-card.vue?vue&type=style&index=0&id=30a5d90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports